// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/assets/css/app.css
// module id = 302
// module chunks = 0